import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Button, Card, Checkbox, Placeholder, Typography } from 'components';
import CalculatorBestOffer from 'components/CalculatorBestOffer/CalculatorBestOffer';
import s from 'pages/Registration/WelcomeBack/WelcomeBack.module.scss';
import useWelcomeBackNewApplication from './useWelcomeBackNewApplication';
import { ClientOffer } from 'hooks/webapi/client/useClientOfferQuery';
import { useTranslation } from 'react-i18next';

export default function WelcomeBackNewApplication() {
  const {
    handleConfirm,
    amount,
    loading,
    offer,
    constraints,
    handleAmountChange,
    pending,
    client,
    consent,
    consentsLoading,
  } = useWelcomeBackNewApplication();
  const { t } = useTranslation();
  const [isConsentAccepted, setIsConsentAccepted] = useState(false);

  const handleConsentToggle = () =>
    setIsConsentAccepted((prevState: boolean) => !prevState);

  return (
    <>
      <Helmet>
        <title>{t('welcome_back:html_title')}</title>
      </Helmet>

      <Typography
        className={s['card-title']}
        size="l"
        fontWeight={600}
        dataTest="welcomeBackNewApplication-title"
      >
        {t('welcome_back:title_new_application', {
          name: client?.firstName,
        })}
      </Typography>

      <div className={s['box-wrapper']}>
        <Card className={s.card} dataTest="welcomeBackNewApplication-card">
          <>
            <CalculatorBestOffer
              calculatorAmount={amount}
              loading={loading}
              constraints={constraints?.amountInterval}
              offer={offer as ClientOffer}
              onAmountChange={handleAmountChange}
              sliderDisabled={pending}
            />
            <div data-test="current-offer-btn" className={s.link} />
          </>
        </Card>
      </div>
      <div className={s['consent-section']} data-test="consent-section">
        <div
          className={s['consent-heading']}
          data-test="welcomeBack-consent-heading"
        >
          {t('welcome_back:consent_heading')}
        </div>
        <Checkbox
          name="consent"
          classNameContent={s['consent-content']}
          value={isConsentAccepted}
          onChange={handleConsentToggle}
          disabled={!consent}
          dataTest="consent-checkbox"
          expand
          pending={consentsLoading || pending}
        >
          <Placeholder loading={!consent}>
            <span
              className={s['consent-text']}
              dangerouslySetInnerHTML={{
                __html: consent || '',
              }}
              data-test="welcomeBack-consent-text"
            />
          </Placeholder>
        </Checkbox>
      </div>

      <Button
        dataTest="new-offer-btn"
        pending={pending}
        onClick={handleConfirm}
        className={s.continue}
        disabled={!offer || !isConsentAccepted}
      >
        {t('welcome_back:button')}
      </Button>
    </>
  );
}
